import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, AutomationInterface, WorkflowStepInterface } from '@vendasta/automata';
import { Observable, switchMap } from 'rxjs';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';
import { ASSOCIATED_CRM_OBJECT_CONFIG } from './constants';
import { AutomationsRouterService } from '../../../../shared/automations-router.service';

@Injectable({ providedIn: 'root' })
export class GetAssociatedCrmObjectService extends AutomationDisplayService {
  constructor(
    protected readonly translateService: TranslateService,
    private readonly router: AutomationsRouterService,
  ) {
    super();
  }

  /** Gets text for the activity column in the table. */
  getActivityColumn(
    namespace: string,
    activity: ActivityInterface,
    automation: AutomationInterface,
  ): ActivityTableEntry {
    const data = activity?.activityData ? JSON.parse(activity.activityData) : {};

    const taskDefinitionId: string = activity.workflowStep!.taskDefinitionId!;
    const activityColumnTranslationKey = ASSOCIATED_CRM_OBJECT_CONFIG[taskDefinitionId].activityColumn;
    const associatedObjectUrl = ASSOCIATED_CRM_OBJECT_CONFIG[taskDefinitionId].associatedObjectUrl;

    return this.tableEntry(
      this.router
        .applyRoutePrefix(`${associatedObjectUrl}/${data?.associated_object_id}`)
        .pipe(
          switchMap((linkToContact) =>
            this.translateService.stream(activityColumnTranslationKey, { url: linkToContact }),
          ),
        ),
      this.getDefaultStepColumnBody(namespace, activity.workflowStep!, automation),
    );
  }

  /** The text in an automation node (i.e. the nodes in the graph). */
  getAutomationNodeData(
    _namespace: string,
    _step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    return this.nodeDisplayData(
      this.translateService.stream(ASSOCIATED_CRM_OBJECT_CONFIG[_step.taskDefinitionId!].automationNode),
      this.noValidationErrorsDetected(),
    );
  }
}
